import { render, staticRenderFns } from "./ProgressBenefitCard.vue?vue&type=template&id=19455418&scoped=true"
import script from "./ProgressBenefitCard.vue?vue&type=script&lang=ts"
export * from "./ProgressBenefitCard.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBenefitCard.vue?vue&type=style&index=0&id=19455418&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19455418",
  null
  
)

export default component.exports